import type { LocationCoordinates } from "@/types/location";

export function formatCoordinatesForClipboard({ lat, lon }: LocationCoordinates): string {
  return `${lat},${lon}`;
}

export async function copyTextToClipboard(text: string): Promise<void> {
  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    const copiedWithClipboardApi = await navigator.clipboard
      .writeText(text)
      .then(() => true)
      .catch(() => false);
    if (copiedWithClipboardApi) {
      return;
    }
  }

  if (typeof document === "undefined") {
    return;
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  textarea.style.pointerEvents = "none";
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
}

export async function copyCoordinatesToClipboard(location: LocationCoordinates): Promise<void> {
  await copyTextToClipboard(formatCoordinatesForClipboard(location));
}
